@if (text) {<div class="error"> {{text}} </div>}